import React from 'react';

import { Typography } from '@material-ui/core';
import MenuItem, { MenuItemProps } from '@material-ui/core/MenuItem';

interface Props {
  innerRef: any;
  innerProps: MenuItemProps;
  isFocused: boolean;
  isSelected: boolean;
  data: {
    key?: string;
    id?: string;
    secondaryText?: string;
  };
}

const SelectOption: React.FC<Props> = ({ children, innerRef, innerProps, isFocused, isSelected, data }) => (
  <MenuItem
    key={data.key || data.id}
    buttonRef={innerRef}
    selected={isFocused}
    component="div"
    style={{
      fontWeight: isSelected ? 500 : 400,
    }}
    {...innerProps}
  >
    <span>
      <Typography>
        <b>{children}</b>
      </Typography>
      {data.secondaryText && <Typography>{data.secondaryText}</Typography>}
    </span>
  </MenuItem>
);

export default SelectOption;
